import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { ArrayUtil, ObjectUtil, StringUtil } from 'src/utils';

interface GroupTypeDTO {
    id: string;
    groupType: string;
    subType: string;
    groupId: string;
    groupName: string;
    //modified: moment.Moment | null;
}
const GroupTypeDTO = {
    create: (initValues?: Partial<GroupTypeDTO>): GroupTypeDTO => {
        const defaults: GroupTypeDTO = {
            id: '',
            groupType: '',
            subType: '',
            groupId: '',
            groupName: '',
          //  modified: null,
        };
        const fixedInitValues: Partial<GroupTypeDTO> = initValues != null
            ? {
                id: StringUtil.IsNullOrEmpty(initValues.id) ? uuidv4() : initValues.id,
               // modified: ObjectUtil.ToMoment(initValues.modified),
            }
            : {};
        return { ...defaults, ...initValues, ...fixedInitValues };
    },
};

export default GroupTypeDTO;
